const ArticleBlockFaqSetup = () => {
  const components = document.querySelectorAll('[data-component-article-block-faq]');

  components.forEach((component) => {
    const items = component.querySelectorAll('.item');
    items.forEach((item, index) => {
      item.querySelector('.question').addEventListener('click', () => {
        if (item.classList.contains('is-active')) {
          closeItem(item);
        } else {
          openItem(item);
        }
        items.forEach((otherItem, otherIndex) => {
          if (index === otherIndex) return;
          if (otherItem.classList.contains('is-active')) closeItem(otherItem);
        });
      });
    });

    const openItem = (item) => {
      item.classList.add('is-active');
      gsap.to(item.querySelector('.answer'), {
        height: 'auto',
        duration: 0.5,
        ease: 'power3.out',
      });
    };

    const closeItem = (item) => {
      item.classList.remove('is-active');
      gsap.to(item.querySelector('.answer'), {
        height: 0,
        duration: 0.5,
        ease: 'power3.out',
      });
    };
  });
};

ArticleBlockFaqSetup();